"use strict";
var r, e;
function a() {
  return e || (e = 1, r = RangeError), r;
}
export {
  a as __require
};
//# sourceMappingURL=index.es306.js.map
